/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import { withPrefix } from 'gatsby'

// material-ui
import { AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'

// custom components
import SEO from '../SEO/SEO'
import ElevationScroll from '../ElevationScroll/ElevationScroll'

/**
 * Header component for article page
 * @param {Object} props - component properties
 * @param {String} props.title - the title of the article
 * @param {String} props.description - the description of the article (excerpt)
 * @param {Object} props.location - representing where the app is from a router perspective
 * @param {Function} props.navigate - provides a means to programmatically navigate
 * @param {*} props.children - children components
 * @returns {*}
 * @constructor
 */
function ArticleHeader({ title, description, location, navigate, siteMeta, children }) {
  const { state = {} } = location
  const to = state && state.referrer ? state.referrer : withPrefix('/')

  return (
    <React.Fragment>
      <SEO title={title} description={description} siteMeta={siteMeta} />
      <ElevationScroll>
        <AppBar color="primary" position="fixed">
          <Toolbar>
            <IconButton onClick={() => navigate(to)} edge="start" color="inherit"  aria-label="menu">
              <ClearIcon />
            </IconButton>
            <Typography variant="subtitle1" color="inherit">
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      {children}
    </React.Fragment>
  )
}

export default ArticleHeader
